import { addDays, differenceInCalendarDays, format, isSameDay } from 'date-fns';

import { TIME_FORMAT, xAgo } from './date';
import { formatDate } from './format-date';

export type FormatDatePastOptions = {
  now?: Date;
  variant?: 'date' | 'relative-date-time';
};

const ONE_HOUR_MS = 60 * 60 * 1000;
const ONE_WEEK_DAYS = 7;
const ONE_MONTH_DAYS = 30;

export function formatDatePast(
  date: Date,
  { now = new Date(), variant = 'date' }: FormatDatePastOptions = {},
): string {
  if (variant === 'relative-date-time') {
    const elapsedMs = now.getTime() - date.getTime();
    if (elapsedMs >= 0 && elapsedMs < ONE_HOUR_MS) {
      return xAgo(date, now);
    }

    const calendarDaysAgo = differenceInCalendarDays(now, date);
    if (calendarDaysAgo === 0) {
      return `today at ${format(date, TIME_FORMAT)}`;
    }
    if (calendarDaysAgo === 1) {
      return `yesterday at ${format(date, TIME_FORMAT)}`;
    }
    if (calendarDaysAgo < 0) {
      return formatDate(date, now);
    }
    if (calendarDaysAgo < ONE_WEEK_DAYS) {
      return `${calendarDaysAgo} days ago`;
    }
    if (calendarDaysAgo < ONE_MONTH_DAYS) {
      return 'more than a week ago';
    }
    return 'more than a month ago';
  }

  const today = now;
  if (isSameDay(date, today)) {
    return 'today';
  }

  if (isSameDay(date, addDays(today, -1))) {
    return 'yesterday';
  }

  return formatDate(date, today);
}
